<form class="space-y-2" [formGroup]="subscribeForm" (ngSubmit)="onSubmit()">
  <input 
    name="email"
    type="email" 
    placeholder="Your email address" 
    autocomplete="email"
    class="w-full p-2 border rounded text-green-800"
    formControlName="email"
    [class.border-red-500]="subscribeForm.get('email')?.invalid && subscribeForm.get('email')?.touched"
    required>
  <button 
    type="submit" 
    [class]="buttonClasses"
    [disabled]="subscribeForm.invalid || isSubmitting">
    {{isSubmitting ? 'Subscribing...' : 'Subscribe'}}
  </button>
</form>
